import React, { useCallback, useEffect } from 'react'
import { Uploader } from '@wmgtech/legato'
import { TAction } from '@wmgtech/legato/build/components/Uploader/types'

import { MAX_FILE_SIZE } from 'shared/consts'
import { uploaderService } from 'shared/services'

import { galleryUrlsVar } from 'modules/Feed/store'

export const useFeedUploader = ({ initialGallery = [] }: { initialGallery: string[] }) => {
  const uploaderServiceDriver = uploaderService()

  const handleAction = useCallback(
    (action: TAction) => {
      if (action === 'clearList') {
        galleryUrlsVar(initialGallery)
      }
    },
    [initialGallery]
  )

  useEffect(() => {
    if (initialGallery.length) galleryUrlsVar(initialGallery)
  }, [initialGallery])

  const FeedUploader = useCallback(
    () => (
      <Uploader
        autoUpload
        multiple
        accept={{
          'image/*': [],
          'application/pdf': []
        }}
        driver={uploaderServiceDriver}
        orientation="vertical"
        disabled={false}
        onAction={handleAction}
        uploaderCaptions={{ info: '', rejectedFiles: 'File size is larger than 3MB' }}
        dropzoneProps={{ maxSize: MAX_FILE_SIZE }}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return { FeedUploader }
}
